<div class="template1">
    <div class="cookies-banner pt-0 pb-2 notification_type_{{bannerNotificationType}}" *ngIf="showCookieBanner && (!isImpersonatedUser || (isImpersonatedUser && bannerNotificationType === 1))" id="app-cookie-banner">
        <div class="container ">
            <button tabindex="1" (keyup.enter)="hideCookie(false)" *ngIf="bannerNotificationType === 1" type="button" (click)="hideCookie(false)" class="close float-right position-relative pointer" aria-label="Close Icon">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="card-content pb-0">
                <!-- <h4 class="cookiesban-title" *ngIf="bannerTitle">
                        <span class="icon-bg" *ngIf="bannerNotificationType === 1">
                                <i class="fa fa-info-circle fa-md" aria-hidden="true"></i>
                            </span>{{'cookieBanner.'+bannerTitle|translate|translateKey}}
                </h4> -->
                <div class="row ">
                    <div tabindex="0" class="cookies-content col-12 col-md-9 col-lg-9 p-0 notification_content_{{bannerNotificationType}}">{{'cookieBanner.'+bannerDescription | translate}}
                        <a *ngIf="bannerNotificationType === 0" target="_blank" [routerLink]="['/' + isoCountryCode + '/' + language + '/comingsoon']" class="px-2">{{'cookieBanner.Read more'|translate|translateKey}}</a>
                    </div>
                    <div class="banner-btn col-12 col-md-2 col-lg-3 p-0 text-right">
                        <button tabindex="0" id="cookieCotinue" attr.aria-label="{{'cookieBanner.Press Continue button' |translate|translateKey}}" class="btn btn-secondary" autofocus (keyup.enter)="hideCookie(true)" (click)="hideCookie(true)">{{'cookieBanner.Continue'|translate|translateKey}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>